import { useFormContext } from "react-hook-form";
import { Tooltip } from "antd";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

const SingleLineLongField = ({
  label,
  top,
  htmlfor,
  register,
  required,
  readOnly,
  tooltip,
}) => {
  const form = useFormContext();
  register = register || form.register;
  if (!register) {
    throw new Error("No form content and no register passed");
  }

  const htmlFor = htmlfor ? htmlfor : label;

  const labelNode = (
    <label
      data-tip="React-tooltip"
      htmlFor={`${htmlFor}`}
      className="flex items-center text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
    >
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
      {tooltip && (
        <Tooltip title={tooltip}>
          <InformationCircleIcon className="h-4 w-4 ml-1 flex-shrink-0 text-gray-400" />
        </Tooltip>
      )}
    </label>
  );

  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start ${
        top ? "" : "sm:border-t"
      } sm:border-gray-200 sm:pt-5 sm:pb-2`}
    >
      {/* Its own tooltip replaces the generic one rather than nesting, which would fire both. */}
      {required && !tooltip ? (
        <Tooltip title="Required field">{labelNode}</Tooltip>
      ) : (
        labelNode
      )}
      <div className="mt-1 sm:mt-0 sm:col-span-2">
        <input
          id={`${label}`}
          name={`${htmlFor}`}
          type="text"
          className="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
          readOnly={readOnly}
          {...register(htmlFor, { required: required })}
        />
      </div>
    </div>
  );
};

export default SingleLineLongField;
